const Clipboard = require('clipboard')
const Hammer = require('hammerjs')
const Fullscreen = require('./fullscreen')
const {bind} = require('../lib/bind')
const cancelEvent = require('../lib/cancel-event')

require('../lib/array-from')
require('../lib/closest')

class Player {
  constructor(element) {
    this.element = element
    new Fullscreen(element)

    this.scrubberElement = element.querySelector('.js-sd-player-scrubber')
    this.progressElement = element.querySelector('.js-sd-player-scrubber-progress')
    this.previewElement = element.querySelector('.js-sd-player-preview')
    this.currentSlideElement = element.querySelector('.js-sd-player-current-slide')
    this.linkBadge = element.querySelector('.js-sd-player-link-badge')
    this.linkBadgeCount = element.querySelector('.js-sd-player-link-badge-count')
    this.linkModal = element.querySelector('.js-sd-player-link-modal')
    this.linkModalOverlay = element.querySelector('.js-sd-player-link-modal-overlay')
    this.linkModalUrl = element.querySelector('.js-sd-player-link-modal-url')
    this.linkModalCopy = element.querySelector('.js-sd-player-link-modal-copy')
    this.linkModalOpen = element.querySelector('.js-sd-player-link-modal-open')
    this.linkModalClose = element.querySelector('.js-sd-player-link-modal-close')
    this.linksEnabled = false
    this.pendingLinkUrl = null
    this.currentSlideNote = element.querySelector('.current-slide-note')
    this.showSlideNotes = false
    this.nextSlideElement = element.querySelector('.js-sd-player-next-slide')
    this.previousSlideElement = element.querySelector('.js-sd-player-previous-slide')
    this.slidePresenterElement = element.querySelector('.js-sd-player-presenter')
    this.ratio = parseFloat(element.dataset.ratio)
    this.draggingScrubber = false
    this.slideCount = this.slideElements().length
    this.embed_width = 560
    this.embed_height = Math.floor(this.embed_width / this.ratio)
    this.preloadSlides()
    this.setupListeners()
    this.sizePreview()
    this.setupNativeShare()
    this.setupClipboards()
    this.showSlide(element.dataset.startSlide)
  }

  preloadSlides(from = 0, count = 3) {
    this.slideElements().slice(Math.max(from, 0), count).forEach(function(element) {
      element.style.backgroundImage = `url('${element.dataset.url}')`
    })
  }

  slideElements() {
    return Array.from(this.element.querySelectorAll('.js-sd-slide'))
  }

  showSlide(index) {
    if (this.isPanning()) {
      return false
    }

    index = parseInt(index)
    this.preloadSlides(index - 3, index + 5);
    const backgroundImage = this.slideElements()[index].style.backgroundImage
    const img = backgroundImage.match(/url\((.*?)\)/)[1].replace(/"/g, '')

    // Create slide links from JSON data attribute
    const linksData = this.slideElements()[index].dataset.links
    const linksArray = JSON.parse(linksData)
    const linksContainer = document.getElementById('sd-player-links')
    linksContainer.innerHTML = '';

    // Exit link mode when changing slides
    this.disableLinkMode()

    linksArray.forEach(item => {
      const slideLink = document.createElement('button')
      slideLink.dataset.id = item.id
      slideLink.dataset.url = item.url
      slideLink.className = 'sd-player-link'
      slideLink.type = 'button'

      // Calculate position and size from point data
      // bottom_left is (x1, y1), top_right is (x2, y2)
      const left = (item.bottom_left.x / item.slide_width) * 100
      const bottom = (item.bottom_left.y / item.slide_height) * 100
      const width = ((item.top_right.x - item.bottom_left.x) / item.slide_width) * 100
      const height = ((item.top_right.y - item.bottom_left.y) / item.slide_height) * 100

      slideLink.style.left = `${left}%`
      slideLink.style.bottom = `${bottom}%`
      slideLink.style.width = `${width}%`
      slideLink.style.height = `${height}%`

      // Click handler for link hotspots
      slideLink.addEventListener('click', this.handleLinkClick.bind(this))

      linksContainer.appendChild(slideLink)
    })

    // Update badge
    if (linksArray.length > 0) {
      this.linkBadgeCount.textContent = linksArray.length
      this.linkBadge.removeAttribute('hidden')
    } else {
      this.linkBadge.setAttribute('hidden', true)
    }

    // Slide Notes
    const slideNote = this.slideElements()[index].dataset.slideNote
    if (slideNote.length) {
      this.currentSlideNote.innerHTML = slideNote.replace(/\n/g, '<br>')
      if (this.showSlideNotes) this.currentSlideNote.removeAttribute('hidden')
    } else {
      this.currentSlideNote.innerHTML = ''
      this.currentSlideNote.setAttribute('hidden', true)
    }

    this.currentSlideElement.style.backgroundImage = backgroundImage

    if (this.slideElements()[index + 1]) {
      this.nextSlideElement.style.backgroundImage = this.slideElements()[index + 1].style.backgroundImage
    } else {
      this.nextSlideElement.style.backgroundImage = null
    }

    if (this.slideElements()[index - 1]) {
      this.previousSlideElement.style.backgroundImage = this.slideElements()[index - 1].style.backgroundImage
    } else {
      this.previousSlideElement.style.backgroundImage = null
    }

    this.currentSlide = index;
    this.disablePreviousNext()
    this.updateScrubberProgress()

    if (this.element.classList.contains('sharing')) {
      this.updateShareLinks()
    }

    var event = new CustomEvent('sd:embed:image', {
      detail: {
        index: index,
        cssUrl: backgroundImage,
        imgUrl: img
      }
    })
    try { window.parent.document.dispatchEvent(event) }
    catch(e){
      console.log(e)
    }
  }
  disablePreviousNext() {
    const previousButtons = Array.from(this.element.querySelectorAll('.js-sd-player-previous'))
    const nextButtons = Array.from(this.element.querySelectorAll('.js-sd-player-next'))

    if (this.isFirstSlide()) {
      previousButtons.forEach((element) => {
        element.classList.remove('active')
      })
    } else {
      previousButtons.forEach((element) => {
        element.classList.add('active')
      })
    }

    if (this.isLastSlide()) {
      nextButtons.forEach((element) => {
        element.classList.remove('active')
      })
    } else {
      nextButtons.forEach((element) => {
        element.classList.add('active')
      })
    }
  }

  setupClipboards() {
    Array.from(this.element.querySelectorAll('[data-clipboard-text]')).forEach((element) => {
      const clipboard = new Clipboard(element)
      clipboard.on('success', (e) => {
        const text = element.innerText
        element.innerText = 'Copied!'
        setTimeout(() => {
          element.innerText = text
        }, 2000)
      })
    })
  }

  getShareUrl() {
    const baseUrl = this.element.dataset.url
    const slideToggle = this.element.querySelector('.js-sd-player-share-slide-toggle')
    if (slideToggle && slideToggle.checked) {
      const slide = this.currentSlide + 1
      return slide > 1 ? `${baseUrl}?slide=${slide}` : baseUrl
    }
    return baseUrl
  }

  updateShareLinks() {
    const url = this.getShareUrl()
    const slide = this.currentSlide + 1
    const slideToggle = this.element.querySelector('.js-sd-player-share-slide-toggle')
    const fromSlide = slideToggle && slideToggle.checked

    // Update URL input and copy button
    const urlInput = this.element.querySelector('.js-sd-player-share-url')
    const urlCopy = this.element.querySelector('.js-sd-player-share-url-copy')
    if (urlInput) urlInput.value = url
    if (urlCopy) urlCopy.dataset.clipboardText = url

    // Update embed buttons
    const iframeBtn = this.element.querySelector('.js-sd-player-embed-iframe')
    const jsBtn = this.element.querySelector('.js-sd-player-embed-js')

    if (iframeBtn && window.frameElement) {
      const doc = new DOMParser().parseFromString(window.frameElement.outerHTML, 'text/html')
      let iframe = doc.querySelector('iframe')
      iframe.src = iframe.src.split('?')[0]
      iframe.style.width = '100%'
      iframe.style.height = 'auto'
      iframe.style.aspectRatio = `${this.embed_width}/${this.embed_height}`
      iframe.setAttribute('data-ratio', this.embed_width / this.embed_height)
      if (fromSlide && slide > 1) iframe.src = iframe.src + `?slide=${slide}`
      iframeBtn.dataset.clipboardText = iframe.outerHTML
    }

    if (jsBtn) {
      // Preserve the original embed snippet separately so we don't repeatedly
      // mutate and re-use an already-modified value as the "base".
      let baseEmbed = jsBtn.dataset.baseClipboardText

      if (!baseEmbed) {
        baseEmbed = jsBtn.dataset.clipboardText || ''
        jsBtn.dataset.baseClipboardText = baseEmbed
      }

      // Start from the immutable base, strip any existing data-slide (defensive),
      // then optionally add the current slide attribute.
      let updatedEmbed = baseEmbed.replace(/ data-slide="\d+"/, '')

      if (fromSlide && slide > 1) {
        updatedEmbed = updatedEmbed.replace(
          'class="speakerdeck-embed"',
          `class="speakerdeck-embed" data-slide="${slide}"`
        )
      }

      jsBtn.dataset.clipboardText = updatedEmbed
    }
  }

  setupNativeShare() {
    const nativeBtn = this.element.querySelector('.js-sd-player-native-share')
    if (!nativeBtn) return

    if (navigator.share) {
      nativeBtn.removeAttribute('hidden')
    } else {
      // Listen for parent window signaling native share support
      bind(window, 'message', (e) => {
        if (e.data && e.data.type === 'sd:native-share-available') {
          this.parentNativeShare = true
          nativeBtn.removeAttribute('hidden')
        }
      })
    }
  }

  handleSocialClick(e) {
    e.preventDefault()
    const network = e.currentTarget.dataset.network
    const socialContainer = this.element.querySelector('.sd-player-share-menu-social')
    const talkUrl = this.getShareUrl()
    const talkTitle = socialContainer.dataset.talkTitle
    const encodedUrl = encodeURIComponent(talkUrl)
    const encodedTitle = encodeURIComponent(talkTitle)
    let shareUrl

    switch (network) {
      case 'facebook':
        const appId = socialContainer.dataset.facebookAppId
        shareUrl = `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&href=${encodedUrl}&title=${encodedTitle}`
        break
      case 'x':
        shareUrl = `https://x.com/intent/tweet?text=${encodedTitle}%20${encodedUrl}%0A%0A%23speakerdeck`
        break
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/shareArticle?url=${encodedUrl}&title=${encodedTitle}`
        break
      case 'reddit':
        shareUrl = `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`
        break
      case 'whatsapp':
        shareUrl = `https://api.whatsapp.com/send/?text=${encodedTitle}%20${encodedUrl}%0A%0A%23speakerdeck&type=custom_url&app_absent=0`
        break
      case 'line':
        shareUrl = `https://social-plugins.line.me/lineit/share?url=${encodedUrl}&text=${encodedTitle}%0A%0A%23speakerdeck`
        break
      case 'bluesky':
        shareUrl = `https://bsky.app/intent/compose?text=${encodedTitle}%20${encodedUrl}%0A%0A%23speakerdeck`
        break
      case 'email':
        const mailSubject = encodeURIComponent(talkTitle)
        const mailBody = encodeURIComponent(talkTitle + '\n' + talkUrl)
        shareUrl = `mailto:?subject=${mailSubject}&body=${mailBody}`
        break
      case 'native':
        if (navigator.share) {
          navigator.share({ title: talkTitle, url: talkUrl }).catch(() => {})
        } else if (this.parentNativeShare) {
          window.parent.postMessage({ type: 'sd:share', title: talkTitle, url: talkUrl }, '*')
        }
        this.trackShare(network, talkUrl)
        return
    }

    if (shareUrl) {
      if (network === 'email') {
        const a = document.createElement('a')
        a.href = shareUrl
        a.target = '_blank'
        a.rel = 'noopener noreferrer'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } else {
        const newWindow = window.open(
          shareUrl,
          '_blank',
          'toolbar=no,menubar=no,location=yes,resizable=yes,scrollbars=yes,status=yes,width=600,height=400,noopener,noreferrer'
        )
        if (newWindow) {
          newWindow.opener = null
        }
      }
      this.trackShare(network, talkUrl)
    }
  }

  trackShare(method, itemId) {
    if (typeof gtag !== 'function') return
    gtag('event', 'share', {
      method: method,
      content_type: 'talk',
      item_id: itemId,
      share_location: 'embed',
      embed_host: document.referrer || ''
    })
  }

  updateScrubberProgress() {
    this.progressElement.style.width = `${100 * this.currentSlide / (this.slideCount - 1)}%`
  }

  isFirstSlide() {
    return this.currentSlide == 0
  }

  isLastSlide() {
    return this.currentSlide == this.slideCount - 1
  }

  showControls() {
    this.element.classList.add('show-controls')
  }

  hideControls() {
    this.removeInitialState()
    this.element.classList.remove('show-controls')
  }

  setupListeners() {
    bind('.js-sd-player-next', 'click', this.clickNext.bind(this))
    bind('.js-sd-player-previous', 'click', this.clickPrevious.bind(this))
    bind(this.scrubberElement, 'mousemove', this.showPreview.bind(this))
    bind(this.scrubberElement, 'mouseout', this.hidePreview.bind(this))
    bind(this.scrubberElement, 'mousedown', this.startScrubberDrag.bind(this))
    bind(this.scrubberElement, 'mouseup', this.endScrubberDrag.bind(this))
    bind('.js-sd-player-share', 'click', this.toggleShare.bind(this))

    this.linkBadge.addEventListener('click', this.toggleLinkMode.bind(this))
    this.linkModalOverlay.addEventListener('click', this.hideModal.bind(this))
    this.linkModalCopy.addEventListener('click', this.copyPendingLink.bind(this))
    this.linkModalOpen.addEventListener('click', this.openPendingLink.bind(this))
    this.linkModalClose.addEventListener('click', this.hideModal.bind(this))
    bind('.js-sd-player-notes', 'click', this.toggleNotes.bind(this))

    bind('.js-sd-player-share-close', 'click', this.hideShare.bind(this))

    const slideToggle = this.element.querySelector('.js-sd-player-share-slide-toggle')
    if (slideToggle) {
      slideToggle.addEventListener('change', this.updateShareLinks.bind(this))
    }

    Array.from(this.element.querySelectorAll('.js-share-social')).forEach((el) => {
      el.addEventListener('click', this.handleSocialClick.bind(this))
    })
    bind(this.element, 'mouseout', this.removeInitialState.bind(this))
    bind(this.element, 'mouseenter', this.showControls.bind(this))
    bind(this.element, 'mouseleave', this.hideControls.bind(this))

    bind(document, 'keydown', (e) => {
      this.handleKeyDown(e.keyCode);
    })

    bind(window, "message", this.receiveMessage.bind(this), false);


    const hammer = new Hammer(this.element, {})
    hammer.get('pan').set({ direction: Hammer.DIRECTION_HORIZONTAL });
    hammer.on('pan', this.handlePan.bind(this));
  }

  clickNext() {
    this.showControls()
    this.nextSlide()
  }

  clickPrevious() {
    this.showControls()
    this.previousSlide()
  }

  handlePan(event) {
    if (this.element.classList.contains('sharing')) {
      return;
    }

    if (event.target.closest('.js-sd-player-scrubber')) {
      return;
    }

    if (!this.isPanning()) {
      this.setPanningOn(event.additionalEvent)
    }

    this.slidePresenterElement.style.transform = `translateX(${event.deltaX}px)`

    if (event.isFinal) {
      if (this.panningDirection == event.additionalEvent) {
        if (event.additionalEvent == 'panright') {
          this.panToPrevious()
        } else {
          this.panToNext()
        }
      } else {
        this.resetPan()
      }
    }
  }

  setPanningOn(direction) {
    this.panning = true
    this.panningDirection = direction
    this.element.classList.add('is-panning')
    this.hideControls()
  }

  setPanningOff() {
    this.panning = false
    this.panningDirection = null
    this.element.classList.remove('is-panning')
  }

  isPanning() {
    return this.panning || false
  }

  panToNext() {
    if (this.isLastSlide()) {
      this.resetPan()
    } else {
      this.slidePresenterElement.style.transform = `translateX(-100%)`

      setTimeout(() => {
        this.setPanningOff()
        this.showSlide(this.currentSlide + 1)
        this.resetPan()
      }, 240)
    }
  }

  panToPrevious() {
    if (this.isFirstSlide()) {
      this.resetPan()
    } else {
      this.slidePresenterElement.style.transform = `translateX(100%)`
      setTimeout(() => {
        this.setPanningOff()
        this.showSlide(this.currentSlide - 1)
        this.resetPan()
      }, 240)
    }
  }

  resetPan(transition = true) {
    this.slidePresenterElement.style.transform = `translateX(0)`
    setTimeout(this.setPanningOff.bind(this), 240)
  }

  removeInitialState() {
    this.element.classList.remove('state-initial')
  }

  toggleShare() {
    this.element.classList.toggle('sharing')
    document.querySelector('.sd-player-share-menu').removeAttribute('hidden')

    if (this.element.classList.contains('sharing')) {
      this.updateShareLinks()
    }
  }

  toggleLinkMode(e) {
    e.preventDefault()
    e.stopPropagation()
    if (this.linksEnabled) {
      this.disableLinkMode()
    } else {
      this.enableLinkMode()
    }
  }

  enableLinkMode() {
    this.linksEnabled = true
    this.element.classList.add('links-enabled')
    this.linkBadge.classList.add('active')
  }

  disableLinkMode() {
    this.linksEnabled = false
    this.element.classList.remove('links-enabled')
    this.linkBadge.classList.remove('active')
    this.hideModal()
  }

  handleLinkClick(e) {
    if (!this.linksEnabled) return

    e.preventDefault()
    e.stopPropagation()

    const url = e.target.dataset.url
    if (!url) return

    this.pendingLinkUrl = url
    this.linkModalUrl.value = url
    this.linkModal.removeAttribute('hidden')
    this.linkModalCopy.focus()
  }

  copyPendingLink(e) {
    e.preventDefault()
    e.stopPropagation()
    if (this.pendingLinkUrl) {
      navigator.clipboard.writeText(this.pendingLinkUrl).then(() => {
        const originalText = this.linkModalCopy.textContent
        this.linkModalCopy.textContent = 'Copied!'
        setTimeout(() => {
          this.linkModalCopy.textContent = originalText
        }, 1500)
      })
    }
  }

  openPendingLink(e) {
    e.preventDefault()
    e.stopPropagation()
    if (this.pendingLinkUrl) {
      window.open(this.pendingLinkUrl, '_blank', 'noopener,noreferrer')
      this.hideModal()
    }
  }

  hideModal(e) {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    this.linkModal.setAttribute('hidden', true)
    this.pendingLinkUrl = null
  }

  toggleNotes(e) {
    e.preventDefault()
    if (this.currentSlideNote.innerHTML.length > 0) document.querySelector('.current-slide-note').toggleAttribute('hidden')
    this.showSlideNotes = !this.showSlideNotes
    document.querySelector('.js-sd-player-notes').classList.toggle('toggled')
  }

  hideShare() {
    this.element.classList.remove('sharing')
    document.querySelector('.sd-player-share-menu').setAttribute('hidden', 'hidden')
    document.querySelector('.sd-player-share').focus()
  }


  startScrubberDrag() {
    this.draggingScrubber = true
  }

  endScrubberDrag() {
    this.draggingScrubber = false
    this.showSlide(this.currentPreviewSlide)
  }

  showPreview(e) {
    cancelEvent(e)
    const slide = Math.round(this.slideCount * e.clientX / this.scrubberElement.offsetWidth)

    this.previewElement.classList.add('active')
    if (slide != this.currentPreviewSlide) {
      this.currentPreviewSlide = slide
      this.previewElement.style.backgroundImage = `url('${this.slideElements()[slide].dataset.previewUrl}')`
      this.positionPreview()
      if (this.draggingScrubber) {
        this.showSlide(this.currentPreviewSlide)
      }
    }
  }

  hidePreview(e) {
    this.previewElement.classList.remove('active')
  }

  sizePreview() {
    this.previewHeight = 80
    this.previewWidth = 80 * this.ratio
    this.previewElement.style.width = `${this.previewWidth}px`
    this.previewElement.style.height = `${this.previewHeight}px`
  }

  positionPreview() {
    const padding = 20
    const scrubberWidth = this.scrubberElement.offsetWidth
    const center = scrubberWidth * this.currentPreviewSlide / (this.slideCount - 1)
    left = center - (this.previewWidth / 2)
    if (left < padding) {
      left = padding
    } else if (left + this.previewWidth > scrubberWidth - padding) {
      left = scrubberWidth - padding - this.previewWidth
    }

    this.previewElement.style.left = `${left}px`
  }

  receiveMessage(e) {
    if (e.origin == `${window.location.protocol}//${window.location.host}` && e.data.type == 'keydown') {
      this.handleKeyDown(e.data.keyCode)
    }
  }

  handleKeyDown(code) {
    if (this.element.classList.contains('sharing')) return

    switch(code) {
      case 39: // right arrow
      case 32: // space
        this.hideControls()
        this.nextSlide()
        break;
      case 37: // left arrow
        this.hideControls()
        this.previousSlide()
        break;
    }
  }

  nextSlide() {
    if (!this.isLastSlide()) {
      this.showSlide(this.currentSlide + 1)
    }
  }

  previousSlide() {
    if (!this.isFirstSlide()) {
      this.showSlide(this.currentSlide - 1)
    }
  }
}

Player.init = () => {
  const element = document.querySelector('.js-sd-player')

  if (element) {
    new Player(element);
  }
}

module.exports = Player;
